import React from 'react';
import { NavLink } from "react-router-dom";

import { pantryData } from '../data/pantry.json';
import { bidData } from '../data/bid.json';


const Ingredients = () => {
  // let match = useRouteMatch();
  // console.log(match.path)

  return (
    <div className="Ingredient_wrap">
      <div className="Ingredient_heading">
        <h1>INGREDIENTS</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud </p>
      </div>
      <div className="Ingradient_tabs">
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" data-toggle="tab" href="#PantryTabs" role="tab">PANTRY</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#BidTabs" role="tab">BID</a>
          </li>
        </ul>
        {/*<!-- Tab panes --> */}
        <div className="tab-content">
          <div className="tab-pane active" id="PantryTabs" role="tabpanel">
            <h3>Pantry Items can be purchased at a fixed cost.</h3>
            <ul>
              {
                pantryData.map((pantryItem) => (
                  <li key={pantryItem.id}>
                    <div className="pantry_img">
                      <img src={pantryItem.img} alt={pantryItem.name} />
                    </div>
                    <p>{pantryItem.name}</p>
                    <button>
                      <NavLink exact to={{
                        pathname: "/pantryitem",
                        data: pantryItem
                      }}>
                        Buy
                        </NavLink>
                    </button>
                  </li>
                ))
              }
            </ul>
          </div>
          <div className="tab-pane" id="BidTabs" role="tabpanel">
            <h3>Bidding Items are xxxxxxxxxxxxxxxxxxx</h3>
            <ul>
              {
                bidData.map((bidItem) => (
                  <li key={bidItem.id}>
                    <div className="pantry_img">
                      <img src={bidItem.img} alt={bidItem.name} />
                    </div>
                    <p>{bidItem.name}</p>
                    <button>
                      <NavLink exact to={{
                        pathname: "/biditem",
                        data: bidItem
                      }}>
                        Bid
                          </NavLink>
                    </button>
                  </li>
                ))
              }
            </ul>
            <div className="bidView_more">
              <button>see more</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ingredients;
